module.exports = __webpack_public_path__ + "img/icon-new@2x.ca85aa8.png";